import {
  Home,
  Store,
  QrCode,
  Receipt,
  Settings,
  Users,
  Wallet,
  Link2,
  Webhook,
} from "lucide-react";

export type MenuItem = {
  label: string;
  href?: string;
  startIcon: React.ComponentType<{ className?: string }>;
  endIcon?: React.ReactNode;
  items?: MenuItem[];
};

export const menuItems: MenuItem[] = [
  {
    label: "Dashboard",
    href: "/dashboard/home",
    startIcon: Home,
  },
  {
    label: "Modo Comerciante",
    href: "/dashboard/merchant",
    startIcon: Store,
  },
  {
    label: "Clientes",
    href: "/dashboard/customers",
    startIcon: Users,
  },
  {
    label: "Criar Link de Pagamento",
    href: "/dashboard/qrcode",
    startIcon: Link2,
  },
  {
    label: "Links de Pagamento",
    href: "/dashboard/payment-links",
    startIcon: Link2,
  },
  {
    label: "Transações",
    href: "/dashboard/transactions",
    startIcon: Receipt,
  },
  {
    label: "Saques",
    href: "/dashboard/withdraw",
    startIcon: Wallet,
  },
  {
    label: "API e Webhooks",
    href: "/dashboard/apis",
    startIcon: Webhook,
  },
];

export const bottomMenuItem: MenuItem = {
  label: "Configurações",
  href: "/dashboard/settings",
  startIcon: Settings,
};
